import React from "react";
import { NavLink } from "react-router-dom";

const SiteProfile = ({ site }) => {
	return (
		<NavLink
			className="text-success"
			to={{
				pathname: `/home/app-management/site-detail/${site.id}`
			}}
		>
			<div className="flex">
				<div className="margin-right-10">
					<img
						width="50"
						className="img-circle user-img-circle"
						src={site.logo || `https://dummyimage.com/50x50&text=${site.name}`}
						alt={site.name}
					/>
				</div>
				<div>
					<strong>{site.name}</strong>
					<p className="text-muted">{site.email}</p>
				</div>
			</div>
		</NavLink>
	);
};

export default SiteProfile;
